export interface IBillingApply {
  headerType?: string;
  invoice_amount?: number; // 开票金额
  invoice_type?: string;
  title_name?: string; // 公司抬头
  email?: string; // 邮箱
  tax_code?: string; // 税号
  organization_address?: string; // 地址
  organization_tel?: string; // 电话
  bank_name?: string; // 开户银行
  bank_account?: string; // 银行账号
}
export interface IField {
  [index: string]: string;
}

export const fieldObject: IField = {
  invoice_amount: '开票金额',
  title_name: '发票抬头',
  tax_code: '税号',
  email: '电子邮箱',
  organization_address: '企业地址',
  organization_tel: '企业电话',
  bank_name: '开户银行',
  bank_account: '银行账号',
};

export const personListArr: string[] = [
  'invoice_amount',
  'title_name',
  'email',
];

export const enterPriseListArr: string[] = [
  'invoice_amount',
  'title_name',
  'tax_code',
  'email',
  'organization_address',
  'organization_tel',
  'bank_name',
  'bank_account',
];

export enum orderStatusEnum {
  noState = 0,
  refunding = 1,
  refundedAll = 2,
  refundedSome = 3,
  overdue = 4,
}

export interface IOrderStatusEnum {
  [orderStatusEnum.noState]: string;
  [orderStatusEnum.refunding]: string;
  [orderStatusEnum.refundedAll]: string;
  [orderStatusEnum.refundedSome]: string;
  [orderStatusEnum.overdue]: string;
}
export interface IOrderList {
  order_status: keyof IOrderStatusEnum; // 0-不做标识，1-退款中，2-全部退款成功，3-部分退款成功，4-超过期限
  id: number; // 订单id
  invoice_status: number; // 0-可申请开票，1-已申请，2-不做展示
  paid_time: number; // 购买时间
  pay_amount: number; // 实付金额
  invoice_amount: number; // 开票金额
  production_name: string; // 商品名称
  is_end_order: number; // 是否尾款订单，1-是，0-否
  deposit_info: {
    deposit_amount: number; // 定金金额
    end_amount: number; // 尾款金额
  };
}

export const OrderStatusMap = {
  [orderStatusEnum.noState]: {
    class: '',
    text: '',
    toast: '',
  },
  [orderStatusEnum.refunding]: {
    class: 'refunding',
    text: '退款中',
    toast: '该订单退款中，不可开票',
  },
  [orderStatusEnum.refundedAll]: {
    class: 'refund-all',
    text: '全部退款成功',
    toast: '该订单没有可开票金额，不可开票',
  },
  [orderStatusEnum.refundedSome]: {
    class: 'refund-some',
    text: '部分退款成功',
    toast: '',
  },
  [orderStatusEnum.overdue]: {
    class: 'overdue',
    text: '超过期限',
    toast: '该订单已超过90天可开发票时限，不可开票',
  },
};

export interface ISelectList {
  id: number;
  name: string;
}

export interface IBillingDetail {
  id: number;
  state: statusEnum;
  invoice_status: number;
  paid_time: number; // 支付时间
  pay_amount: number; // 支付购买金额
  invoice_amount: number; // 开票金额
  production_name: string; // 商品名称
  apply_time: number; // 申请时间
  invoice_time: number; // 开具时间
  title_type: string; // 抬头类型,enterprise-企业,personal-个人
  title_name: string; // 抬头名称
  tax_code: string; // 税号
  email: string; // 抬头名称
  organization_address: string; // 企业地址
  organization_tel: string; // 企业电话
  bank_name: string; // 银行名称
  bank_account: string; // 银行账号
  order_no: string; // 商户编号
  order_id: string; // 订单编号
  card_status: number; // 卡券状态，0-未领取，1-已领取
  we_chat_card_url: string; // 微信地址
}

export interface IGoodsInfo {
  goodsName: string;
  goodsOrderCode: string;
  goodsOrderTime: number;
  goodsOrderMoney: number;
}

export enum headerTypeEnum {
  personal = 'personal',
  enterprise = 'enterprise',
}

export const headerTypeObject = {
  [headerTypeEnum.personal]: '1',
  [headerTypeEnum.enterprise]: '2',
};

export enum showTypeSize {
  all = 8,
  some = 4,
}

export enum statusEnum {
  oldData = 'old_data',
  committed = 'committed',
  edited = 'edited',
  blue_requested = 'blue_requested',
  blue_ok = 'blue_ok',
  active_blue_ok = 'active_blue_ok',
  passive_red_requested = 'passive_red_requested',
  passive_red_ok = 'passive_red_ok',
  passive_blue_requested = 'passive_blue_requested',
  passive_blue_ok = 'passive_blue_ok',
  active_red_requested = 'active_red_requested',
  active_red_ok = 'active_red_ok',
  refunding = 'refunding',
  refunded = 'refunded',
  canceled = 'canceled',
  /** 开票失败-邮箱错误 */
  blue_error_mail = 'blue_error_mail',
  /** 开票失败-抬头/税号错误 */
  blue_error_title_tax = 'blue_error_title_tax',
  /** 开票失败-其它错误 */
  blue_error_other = 'blue_error_other',
}
export enum pageShowStatusEnum {
  invoicing = 'invoicing', // 开票中
  invoiceSuccess = 'invoiceSuccess', // 开票成功
  invoiceError = 'invoiceError', // 开票失败
  voided = 'voided', // 已作废
  reseted = 'reseted', // 已撤销
}

export enum editType {
  default = 0, // 默认
  normal = 1, // 正常
  refund = 2, // 退款
  redFlush = 3, // 冲红
  reset = 4, // 撤销
  failed = 5, // 失败后重开
}

interface IStatusObject {
  class: {
    background: string;
    color: string;
  };
  text: string;
  pageShowStatus: pageShowStatusEnum;
  toast: string;
  editType: editType;
  reopen: boolean;
  tipText?: string;
}

export const billingStatusObject: {
  [key in statusEnum]: IStatusObject;
} = {
  [statusEnum.oldData]: {
    class: {
      background: 'rgba(32, 171, 76, 0.1)',
      color: '#20AB4C',
    },
    text: '已开票',
    pageShowStatus: pageShowStatusEnum.invoiceSuccess,
    toast: '',
    editType: editType.normal,
    reopen: false,
  },
  [statusEnum.committed]: {
    class: {
      background: 'rgba(103, 65, 239, 0.1)',
      color: '#6741EF',
    },
    text: '开票中',
    pageShowStatus: pageShowStatusEnum.invoicing,
    toast: '',
    tipText: '开票申请中，我们将在7天内完成审核',
    editType: editType.normal,
    reopen: false,
  },
  [statusEnum.edited]: {
    class: {
      background: 'rgba(103, 65, 239, 0.1)',
      color: '#6741EF',
    },
    text: '开票中',
    pageShowStatus: pageShowStatusEnum.invoicing,
    toast: '不允许修改',
    editType: editType.normal,
    reopen: false,
  },
  [statusEnum.blue_requested]: {
    class: {
      background: 'rgba(103, 65, 239, 0.1)',
      color: '#6741EF',
    },
    text: '开票中',
    pageShowStatus: pageShowStatusEnum.invoicing,
    toast: '不允许修改',
    editType: editType.normal,
    reopen: false,
  },
  [statusEnum.blue_ok]: {
    class: {
      background: 'rgba(32, 171, 76, 0.1)',
      color: '#20AB4C',
    },
    text: '已开票',
    pageShowStatus: pageShowStatusEnum.invoiceSuccess,
    toast: '',
    editType: editType.default,
    reopen: true,
  },
  [statusEnum.active_blue_ok]: {
    class: {
      background: 'rgba(32, 171, 76, 0.1)',
      color: '#20AB4C',
    },
    text: '已开票',
    pageShowStatus: pageShowStatusEnum.invoiceSuccess,
    toast: '',
    editType: editType.default,
    reopen: true,
  },
  [statusEnum.passive_red_requested]: {
    class: {
      background: 'rgba(32, 171, 76, 0.1)',
      color: '#20AB4C',
    },
    text: '已开票',
    pageShowStatus: pageShowStatusEnum.invoiceSuccess,
    toast: '',
    editType: editType.default,
    reopen: true,
  },
  [statusEnum.passive_red_ok]: {
    class: {
      background: 'rgba(49, 40, 93, 0.1)',
      color: '#7C7798',
    },
    text: '已作废',
    pageShowStatus: pageShowStatusEnum.voided,
    toast: '该订单没有可开票金额，不可开票',
    editType: editType.redFlush,
    reopen: true,
  },
  [statusEnum.passive_blue_requested]: {
    class: {
      background: 'rgba(103, 65, 239, 0.1)',
      color: '#6741EF',
    },
    text: '开票中',
    pageShowStatus: pageShowStatusEnum.invoicing,
    toast: '不允许修改',
    editType: editType.normal,
    reopen: false,
  },
  [statusEnum.passive_blue_ok]: {
    class: {
      background: 'rgba(32, 171, 76, 0.1)',
      color: '#20AB4C',
    },
    text: '已开票',
    pageShowStatus: pageShowStatusEnum.invoiceSuccess,
    toast: '',
    editType: editType.normal,
    reopen: true,
  },
  [statusEnum.active_red_requested]: {
    class: {
      background: 'rgba(32, 171, 76, 0.1)',
      color: '#20AB4C',
    },
    text: '已开票',
    pageShowStatus: pageShowStatusEnum.invoiceSuccess,
    toast: '',
    editType: editType.normal,
    reopen: true,
  },
  [statusEnum.active_red_ok]: {
    class: {
      background: 'rgba(49, 40, 93, 0.1)',
      color: '#7C7798',
    },
    text: '已作废',
    pageShowStatus: pageShowStatusEnum.voided,
    toast: '没有可重开发票金额',
    editType: editType.redFlush,
    reopen: true,
  },
  [statusEnum.refunding]: {
    class: {
      background: 'rgba(255, 111, 121, 0.1)',
      color: '#FF6F79',
    },
    text: '开票失败',
    pageShowStatus: pageShowStatusEnum.invoiceError,
    toast: '',
    editType: editType.refund,
    reopen: false,
  },
  [statusEnum.refunded]: {
    class: {
      background: 'rgba(255, 111, 121, 0.1)',
      color: '#FF6F79',
    },
    text: '开票失败',
    pageShowStatus: pageShowStatusEnum.invoiceError,
    toast: '该订单没有可开票金额，不可开票',
    editType: editType.refund,
    reopen: true,
  },
  [statusEnum.canceled]: {
    class: {
      background: 'rgba(49, 40, 93, 0.1)',
      color: '#7C7798',
    },
    text: '已撤销',
    pageShowStatus: pageShowStatusEnum.reseted,
    toast: '该订单没有可开票金额，不可开票',
    editType: editType.reset,
    reopen: true,
  },
  [statusEnum.blue_error_mail]: {
    class: {
      background: 'rgba(255, 111, 121, 0.1)',
      color: '#FF6F79',
    },
    text: '开票失败',
    pageShowStatus: pageShowStatusEnum.invoiceError,
    toast: '该订单没有可开票金额，不可开票',
    tipText: '邮箱无效，请重新申请开票',
    editType: editType.failed,
    reopen: true,
  },
  [statusEnum.blue_error_title_tax]: {
    class: {
      background: 'rgba(255, 111, 121, 0.1)',
      color: '#FF6F79',
    },
    text: '开票失败',
    pageShowStatus: pageShowStatusEnum.invoiceError,
    toast: '该订单没有可开票金额，不可开票',
    tipText: '发票抬头和税号有误，请重新申请开票',
    editType: editType.failed,
    reopen: true,
  },
  [statusEnum.blue_error_other]: {
    class: {
      background: 'rgba(255, 111, 121, 0.1)',
      color: '#FF6F79',
    },
    text: '开票失败',
    pageShowStatus: pageShowStatusEnum.invoiceError,
    toast: '该订单没有可开票金额，不可开票',
    tipText: '开票失败，请确认所填发票信息是否正确',
    editType: editType.failed,
    reopen: true,
  },
};

export enum cardStatusEnum {
  notclaimed = 0,
  Received = 1,
}

export const cardStatusText = {
  [cardStatusEnum.notclaimed]: '领取到微信卡包',
  [cardStatusEnum.Received]: '已领取到微信卡包',
};

export interface IGoodsInfo {
  goodsName: string;
  goodsOrderCode: string;
  goodsOrderTime: number;
  goodsOrderMoney: number;
  goodsInvoiceAmount: number;
}

export enum EOperate {
  add = 'add',
  edit = 'edit',
}

export enum aliveComponentsEnum {
  billingErrorNetwork = 'billingErrorNetwork',
  billingErrorRefunded = 'billingErrorRefunded',
  billingDetail = 'billingDetail',
}

export enum resStatusEnum {
  billingSuccess = 1,
  billingErrorRefunding = 2,
  billingErrorRefunded = 3,
}

export const statusForComponents = {
  [resStatusEnum.billingSuccess]: 'billingSuccess',
  [resStatusEnum.billingErrorRefunding]: 'billingErrorRefunding',
  [resStatusEnum.billingErrorRefunded]: 'billingErrorRefunded',
};

export enum errcodeEnum {
  success = 0,
  error = 1,
}

export enum resetStateEnum {
  billingResetSuccess = 'billingResetSuccess',
  billingResetError = 'billingResetError',
}
